import type { AuthUser } from '../types/auth';

import { normalizeUser } from '../utils/normalizeUser';

const TOKEN_KEY = 'token';
const USER_KEY = 'auth_user';

export const storeToken = (token: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem(TOKEN_KEY);
};

export const getStoredUser = (): AuthUser | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const storedUser = localStorage.getItem(USER_KEY);

  if (!storedUser) {
    return null;
  }

  try {
    const parsedUser = JSON.parse(storedUser);

    return normalizeUser(parsedUser);
  } catch {
    localStorage.removeItem(USER_KEY);

    return null;
  }
};

export const persistUser = (
  user: AuthUser | null
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!user) {
    localStorage.removeItem(USER_KEY);
    return;
  }

  const normalizedUser = normalizeUser(user);

  localStorage.setItem(
    USER_KEY,
    JSON.stringify(normalizedUser)
  );
};